export default __webpack_public_path__ + "static/media/rex.0181d023.png";